export default __webpack_public_path__ + "static/media/fw-zoe-er-Yellow Gold.1f2b85c6.mp4";